<template>
  <div class="job-detail-row job-detail-row--evaluation job-detail-row--ready">
    <div class="job-detail-col job-detail-col--w50 job-detail-col--nomargin">
      <div class="job-detail-workpanel">
        <div class="job-detail-workpanel-col">
          <router-link
            v-if="reportData.ID"
            :to="{ name: 'reports.detail', params: { id: reportData.ID } }"
            class="link link-white job-detail-workpanel-goreport"
          >
            <svg>
              <use
                xlink:href="/img/icons/icons-sprite.svg#icon-share-group"
              ></use>
            </svg>
            <span>Report</span>
          </router-link>

          <div class="job-detail-workpanel-select-proofreader">
            <div class="job-detail-workpanel-title">Evaluation</div>
            <div class="job-detail-workpanel-text">
              Proofreader:
              <span class="job-detail-workpanel-border"
                >{{ job.proofreaderJson.FirstName }}
                {{ job.proofreaderJson.LastName }}</span
              >
            </div>
            <svg class="icon-check">
              <use xlink:href="/img/icons/icons-sprite.svg#icon-check"></use>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="job-detail-col job-detail-col--w50">
      <div class="job-detail-workpanel">
        <div class="job-detail-workpanel-wrapper">
          <div class="job-detail-workpanel-wrapper-col">
            <div class="job-detail-workpanel-title">
              <span class="icon-info">Validation</span>
            </div>
            <div class="job-detail-workpanel-text">
              A QA expert needed to be assigned
            </div>
          </div>
        </div>
        <div class="job-detail-workpanel-wrapper">
          <button
            :class="[
              'btn btn-white-border job-detail-workpanel-btn',
              showExecutors ? 'active' : ''
            ]"
            @click="$emit('showExecutors')"
            type="button"
          >
            Add a QA expert
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    job: {
      type: Object,
      default: () => ({}),
    },
    showExecutors: {
      type: Boolean,
      default: false,
    },
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
});
</script>
